import { Injectable } from '@angular/core';
import {    CanActivate,
            CanActivateChild,
            ActivatedRouteSnapshot,
            RouterStateSnapshot,
            Router
        } from '@angular/router';
import { Observable } from 'rxjs';

import { User } from '../_models/user.model';
import { StorageService } from '../_services/storage.service';
import { AuthService } from '../_services/auth.service';
import { Routes } from '../_config/routes.config';

@Injectable()
export class AuthGuard implements CanActivate {

    private user: User;

    constructor(private router: Router,
                private storageService: StorageService,
                private authService: AuthService
    ) {
        this.storageService.userInfo.subscribe(user => this.user = user);
    }

    canActivate(next: ActivatedRouteSnapshot,
                state: RouterStateSnapshot):
            Promise<boolean> | Observable<boolean> | boolean {
        if (this.user && this.authService.getToken() && this.authService.getToken() != '') {

          // console.log(this.router.url)
            return true;
        }
        this.router.navigate([Routes.LOGIN]);
        return false;
    }

}
